<template>
    <page-loading v-if="loading"></page-loading>
    <form-container v-else>
        <page-header class="mb-6 lg:mb-12">
            <template v-slot:subtitle>
                <a
                    :href="`/settings/teams/${teamId}#/membership`"
                    class="no-underline! text-sky-600! text-base font-normal"
                >
                    <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                    All Users
                </a>
            </template>

            {{ props.user.name }}
        </page-header>

        <div class="grid grid-cols-12">
            <page-sidebar appearance="nested" :links="sidebarLinks"></page-sidebar>

            <slot></slot>
        </div>
    </form-container>
</template>

<script lang="ts" setup>
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed, inject } from 'vue';
import PageLoading from '~/components/general/PageLoading.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import FormContainer from '~/components/general/FormContainer.vue';
import type { TeamUser } from './useTeamUserDetails';
import type { Features } from '~/provides/features.types';

const teamId = Spark.state.currentTeam.id;
const FEATURES = inject('FEATURES') as Features;

const props = defineProps<{
    userId: number;
    user: TeamUser;
    loading: boolean;
}>();

const sidebarLinks = computed(() => {
    const links = [
        {
            href: `/settings/teams/${teamId}/membership/${props.userId}`,
            label: 'Details',
        },
    ];

    if (FEATURES.contact_groups) {
        links.push({
            href: `/settings/teams/${teamId}/membership/${props.userId}/target-access`,
            label: 'Target Access',
        });
    }

    return links;
});
</script>
